import { createContext } from 'react'

import type { AuthState } from './AuthState'

export const AuthContext = createContext<AuthState | undefined>(undefined)
